import { expected } from '@aloft/toolkit-shared';

import { useContext } from 'react';

import { ModuleContext } from './ModuleContext';
import { ModuleContextDef } from './types';

/**
 * @deprecated Use underlying contexts instead
 */
export const useModuleContext = (): ModuleContextDef => {
  const ctx = expected(useContext(ModuleContext), 'must be called within a ModuleContext.Provider');
  return ctx;
};
